<template>
  <div class="luck-draw" :class="{'lottery-turntable': cloneComdata.lotteryMode == 'lottery-turntable'}">
		<!-- 大转盘 -->
		<template v-if="cloneComdata.lotteryMode == 'lottery-turntable'"> 
			<div class="luckyWheel-frequency"> 今日剩余抽奖次数：0</div>
			<LuckyWheel
				width="360px"
				height="360px"
				:prizes="prizePool"
				:blocks="blocks"
				:buttons="buttons"
				class="LuckyWheel"
				v-show="!isEdit"
			/>
			<img
				class="bottom-img"
				src="https://img3.quanyou.com.cn/joyNew/group1/M00/0B/D0/rB8LrmRbU8KAOFi8AAC9G0jbUVQ388.png"
			/>
		</template>
		<!-- 九宫格 -->
		<template v-else>
			<div class="frequency">
				今日剩余抽奖次数： 0
			</div>
			<div class="box">
				<div class="box-item" 
					v-for="(item,index) in prizePool" 
					:key="index"
				>
					<img class="item-icon"
						:src="item.imgs[0].src"
						model="widthFix" 
					/>
					<div class="name">
					{{item.fonts[0].text}}
					</div>
				</div>
			</div>
			<img class="bottom-img"  src="https://img3.quanyou.com.cn/joy/group1/M00/12/4C/rB4ChWKygeWAX6_MAAFSXDSLXME487.png" />
		</template>
		<div class="name-list">
			<div class="header-box">
				<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyhHeAb4zuAAAKR18NbGI814.png" />
				<div class="title">中奖名单</div>
				<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyhHeAb4zuAAAKR18NbGI814.png" />
			</div>
			<div class="list-box">
				当前为预览活动，暂无中奖名单
			</div>
		</div>
	</div>
</template>

<script>
import mixins from './mixins'
export default { 
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
.luck-draw {
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	height: 778px;
	background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4B/rB4ChWKyc5mAW4ncAAPrklX6hOQ138.png');
	background-size: 100% 100%;
	.frequency {
		font-size: 11px;
		color:#FCE9BE;
		margin-top: 108px;
	}
	.box {
		display: flex;
		flex-flow: wrap
		justify-content: center;
		width: 76%;
		height: 282px;
		margin-top: 48px;
		.box-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			// width: 88px;
			width: 32%;
			height: 88px;
			margin: 0 5px 5px 0;
			background: url('https://img3.quanyou.com.cn/joy/group1/M00/13/43/rB4ChWLNPl-AeJKUAAAZNtjanXk733.png');
			background-size: 100% 100%;
			.item-icon {
				margin-top: 4px;
				width: 70px;
				height: 62px;
			}
			.name {
				color: #C55C2E;
				font-size: 10px;
				margin-top: 5px;
			}
		}
		.acitve-item {
			background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4B/rB4ChmKyjWiAA2IkAAAbMGbPXIs292.png');
			background-size: 100% 100%;
		}
		.box-item:nth-child(3n) {
			margin-right: 0;
		}
	}
	.bottom-img {
		width: 255px;
		height: 81px;
		margin-top: 24px;
	}
	.name-list {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 90%;
		height: 120px;
		margin-top: 55px;
		.header-box {
			display: flex;
			align-items: center;
			.icon1 {
				width: 21px;
				height: 10px;
			}
			.title {
				color: #F4D897;
				font-size: 13px;
				margin: 0 5px;
			}
		}
		.list-box {
			display: flex;
			justify-content: center;
			align-items: center
			width: 86%;
			height: 100px;
			color: #f4d897;
		}
	}
}
.lottery-turntable {
	width: 100%;
	height: 870px;
	background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/0B/CF/rB8LrWRbPXWAX8fzAAZ8RtPwofM973.png');
	background-size: 100% 100%;
	.luckyWheel-frequency {
		width: 230px;
		height: 31px;
		font-size: 13px;
		color: #FFFFFF;
		font-weight: 400;
		line-height 31px;
		text-align: center;
		margin-top: 165px;
		border-top: 1px solid #FFFFFF;
		border-bottom: 1px solid #FFFFFF;
	}
	.LuckyWheel {
    margin-top: 10px;
  }
	.bottom-img {
		width: 219px;
		height: 71px;
		margin-top: 24px;
	}
}
</style>
